import { AppBar, Box, Stack, Toolbar, Typography } from "@mui/material";
import { Logo } from "../../../../Common/Components";
import { AppsMenu, NotificationButton, Profile, TestEnvBanner } from "./Containers";

interface IHeader {
  handleProfileDrawerOpen: () => void;
  handleReportBugDrawerOpen: () => void;
  handleNotificationDrawerOpen: () => void;
  handleTermsOfServiceDialogOpen: () => void;
  handleTipsDialogOpen: () => void;
  handlePrivacyPolicyDialogOpen: () => void;
  isMessageCenterEnabled: boolean;
  unreadCount: number;
}

export const Header: React.FC<IHeader> = (props) => {
  const {
    handleProfileDrawerOpen,
    handleNotificationDrawerOpen,
    handleReportBugDrawerOpen,
    handleTermsOfServiceDialogOpen,
    handleTipsDialogOpen,
    handlePrivacyPolicyDialogOpen,
    isMessageCenterEnabled,
    unreadCount,
  } = props;
  return (
    <AppBar component={"nav"} position="fixed">
      <Toolbar>
        <TestEnvBanner />
        <Box sx={{ flex: 1 }}>
          <Stack direction="row" sx={{ alignItems: "center" }} spacing={2}>
            <Logo to={import.meta.env.VITE_LANDING_PAGE_URL} />
          </Stack>
        </Box>
        <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
          <Typography variant="body1" sx={{ fontWeight: "fontWeightSemiBold" }}>
            Pilot Release
          </Typography>
          {isMessageCenterEnabled && (
            <NotificationButton handleClick={handleNotificationDrawerOpen} unreadCount={unreadCount} />
          )}
          {/* Apps Menu */}
          <AppsMenu />

          <Profile
            handleProfileDrawerOpen={handleProfileDrawerOpen}
            handleReportBugDrawerOpen={handleReportBugDrawerOpen}
            handleTermsOfServiceDialogOpen={handleTermsOfServiceDialogOpen}
            handleTipsDialogOpen={handleTipsDialogOpen}
            handlePrivacyPolicyDialogOpen={handlePrivacyPolicyDialogOpen}
          />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
